module.exports = __webpack_public_path__ + "static/media/joinme_m2.f168f995.png";